import React, { ReactNode, useState } from "react";

interface CustomTooltipProps {
  tooltip?: string;
  children: ReactNode;
  tooltipClass?: string;
  customContainerStyle?: JObj;
  htmlTooltip?: string;
}
const CustomTooltip: React.FC<CustomTooltipProps> = ({
  tooltipClass,
  tooltip,
  children,
  customContainerStyle,
  htmlTooltip,
}) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  return (
    <div
      style={
        customContainerStyle || {
          position: "relative",
          display: "flex",
          flex: 1,
        }
      }
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}
      {showTooltip && (
        <>
          <div className={`${tooltipClass} ${showTooltip ? "show" : ""}`}>
            {htmlTooltip ? (
              <div dangerouslySetInnerHTML={{ __html: htmlTooltip }}></div>
            ) : (
              <> {tooltip}</>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CustomTooltip;
